export default __webpack_public_path__ + "static/media/publicCGIARLogo.a5700afd.svg";